<div class="landing-shell" (click)="closeMenu()">
  <header class="landing-topbar" (click)="$event.stopPropagation()">
    <div class="landing-topbar__inner">
      <a routerLink="/" class="landing-topbar__brand">
        <img [src]="logoType" alt="Watch This Garage">
      </a>

      <a id="menu-button" href="#" class="landing-topbar__burger" (click)="onMenuButtonClick($event)">
        <i class="pi pi-bars"></i>
      </a>

      <div #menu id="menu" class="landing-menu" (animationend)="onMenuAnimationEnd()">
        <nav class="landing-menu__nav">
          <ul class="landing-menu__group landing-menu__group--sections">
            <li *ngFor="let sectionLink of visibleTopbarSectionLinks">
              <a
                class="landing-menu__link landing-menu__link--section"
                [href]="sectionLink.section"
                (click)="handleSectionNavigation($event, sectionLink.section!)"
              >
                {{ sectionLink.labelKey | translate }}
              </a>
            </li>
          </ul>

          <ul class="landing-menu__group landing-menu__group--modules">
            <li *ngFor="let routeLink of topbarRouteLinks">
              <a class="landing-menu__link landing-menu__link--module" [routerLink]="routeLink.route" (click)="closeMenu()">
                {{ routeLink.labelKey | translate }}
              </a>
            </li>
          </ul>

          <div class="landing-menu__actions">
            <button
              pButton
              pRipple
              type="button"
              text
              class="landing-topbar__login"
              [routerLink]="['/login']"
              [label]="'auth.login.button.sign_in' | translate"
              (click)="closeMenu()"
            ></button>

            <button
              pButton
              pRipple
              type="button"
              class="landing-topbar__register"
              [routerLink]="['/registration']"
              [label]="'auth.registration.button.register' | translate"
              (click)="closeMenu()"
            ></button>

            <div class="landing-topbar__install">
              <app-install-cta [compact]="true"></app-install-cta>
            </div>

            <div class="landing-topbar__language">
              <app-language-dropdown-button
                [classList]="'landing-topbar__language-button'"
                [showCurrentLanguageLabel]="true"
                (languageChanged)="handleTranslationChange()"
              ></app-language-dropdown-button>
            </div>
          </div>
        </nav>
      </div>
    </div>
  </header>

  <div class="landing-viewport">
    <div class="landing-scroll">
      <div id="header" class="landing-hero-anchor"></div>

      <div class="parallax__layer__0 landing-hero__layer landing-hero__layer--background">
        <img [attr.draggable]="false" [src]="heroLayer0" class="landing-hero__image landing-hero__image--cover" alt="" />
        <div class="landing-hero__overlay"></div>
      </div>

      <div class="parallax__layer__1 landing-hero__layer landing-hero__layer--mid">
        <img [attr.draggable]="false" [src]="heroLayer1" class="landing-hero__image" alt="" />
      </div>

      <div class="parallax__layer__3 landing-hero__headline">
        <div class="landing-hero__headline-inner">
          <h1 class="landing-hero__headline-top">{{ 'landing.hero.lead' | translate }}</h1>
          <h1 class="landing-hero__headline-word">{{ 'landing.hero.word' | translate }}</h1>
          <div class="landing-hero__headline-tail-wrap">
            <h1 class="landing-hero__headline-bottom">{{ 'landing.hero.tail' | translate }}</h1>
          </div>
        </div>
      </div>

      <div class="parallax__layer__2 landing-hero__layer landing-hero__layer--front">
        <img [attr.draggable]="false" [src]="heroLayer2" class="landing-hero__image" alt="" />
      </div>

      <div class="landing-hero__support">
        <span class="landing-chip landing-hero__badge">{{ 'landing.hero.badge' | translate }}</span>
        <h2 class="landing-hero__support-title">{{ 'landing.hero.title' | translate }}</h2>
        <p class="landing-hero__support-subtitle">{{ 'landing.hero.subtitle' | translate }}</p>
        <p class="landing-hero__description landing-hero__description--support">{{ 'landing.hero.description' | translate }}</p>
        <p class="landing-hero__note landing-hero__note--support">{{ 'landing.hero.primary_cta_note' | translate }}</p>

        <div class="landing-hero__highlights">
          <span class="landing-hero__highlight">{{ 'landing.hero.highlights.projects' | translate }}</span>
          <span class="landing-hero__highlight">{{ 'landing.hero.highlights.community' | translate }}</span>
          <span class="landing-hero__highlight">{{ 'landing.hero.highlights.visibility' | translate }}</span>
        </div>
      </div>

      <div class="parallax__layer__3 landing-hero__action">
        <div class="landing-hero__cta-stack">
          <button
            pButton
            pRipple
            [label]="'landing.hero.cta' | translate"
            [routerLink]="['/registration']"
            class="landing-hero__cta-button"
            text
          ></button>

          <div *ngIf="shouldShowRegistrationCountdown" class="landing-countdown">
            <h3>{{ 'landing.registration_open_on' | translate }}</h3>
            <countdown #cd *ngIf="config" [config]="config"></countdown>
          </div>
        </div>
      </div>

      <div class="landing-hero__mobile" [style.background-image]="'linear-gradient(180deg, rgba(1, 5, 13, 0.12), rgba(1, 5, 13, 0.48) 48%, rgba(0, 0, 0, 0.84) 100%), url(' + heroMobileImage + ')'">
        <img [attr.draggable]="false" [src]="heroMobileMidImage" class="landing-hero__mobile-layer landing-hero__mobile-layer--mid" alt="" />
        <img [attr.draggable]="false" [src]="heroMobileFrontImage" class="landing-hero__mobile-layer landing-hero__mobile-layer--front" alt="" />

        <div class="landing-hero__mobile-copy">
          <span class="landing-chip landing-hero__badge">{{ 'landing.hero.badge' | translate }}</span>

          <div class="landing-hero__mobile-wordmark">
            <span class="landing-hero__mobile-lead">{{ 'landing.hero.lead' | translate }}</span>
            <span class="landing-hero__mobile-word">{{ 'landing.hero.word' | translate }}</span>
            <span class="landing-hero__mobile-tail">{{ 'landing.hero.tail' | translate }}</span>
          </div>

          <h2 class="landing-hero__mobile-title">{{ 'landing.hero.title' | translate }}</h2>
          <p class="landing-hero__mobile-subtitle">{{ 'landing.hero.subtitle' | translate }}</p>

          <button
            pButton
            pRipple
            [label]="'landing.hero.cta' | translate"
            [routerLink]="['/registration']"
            class="landing-hero__cta-button landing-hero__cta-button--mobile"
            text
          ></button>

          <p class="landing-hero__description landing-hero__description--mobile">{{ 'landing.hero.description' | translate }}</p>
          <p class="landing-hero__note landing-hero__note--mobile">{{ 'landing.hero.primary_cta_note' | translate }}</p>

          <div *ngIf="shouldShowRegistrationCountdown" class="landing-countdown landing-countdown--mobile">
            <h3>{{ 'landing.registration_open_on' | translate }}</h3>
            <countdown #cdMobile *ngIf="config" [config]="config"></countdown>
          </div>
        </div>
      </div>

      <div id="parallaxBody" class="landing-body">
<!--        <section class="landing-logo-strip">-->
<!--          <div class="landing-frame">-->
<!--            <div class="grid grid-nogutter">-->
<!--              <div *ngFor="let logo of logoStrip" class="col-6 lg:col-3 landing-logo-strip__item">-->
<!--                <img [draggable]="false" [src]="logo" alt="" />-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </section>-->

        <section id="features" class="landing-features">
          <div class="landing-frame">
            <ng-container *ngIf="shouldShowExtendedLandingContent">
            <div class="landing-features__header">
              <div class="landing-chip landing-features__eyebrow">{{ 'landing.pillars.badge' | translate }}</div>
              <span class="landing-section-pretitle">{{ 'landing.pillars.title' | translate }}</span>
              <h1 class="landing-gradient-title">{{ 'landing.feature_grid.word' | translate }}</h1>
              <p class="landing-section-copy landing-section-copy--lead">{{ 'landing.sub_title' | translate }}</p>
              <p class="landing-section-copy">{{ 'landing.pillars.description' | translate }}</p>
              <p class="landing-section-statement">{{ 'landing.mission_slogan_1' | translate }}</p>
            </div>

            <div class="grid grid-nogutter landing-card-grid">
              <div *ngFor="let featureItem of moduleItems" class="col-12 md:col-6 lg:col-3 landing-card-grid__item">
                <article class="landing-feature-card landing-feature-card--module">
                  <i [class]="featureItem.icon + ' landing-feature-card__icon'"></i>
                  <span class="landing-feature-card__title">{{ featureItem.titleKey | translate }}</span>
                  <span class="landing-feature-card__description">{{ featureItem.descriptionKey | translate }}</span>

                  <a
                    *ngIf="featureItem.section"
                    class="landing-card-link"
                    [href]="featureItem.section"
                    (click)="handleFeatureNavigation($event, featureItem)"
                  >
                    {{ 'landing.learn_more' | translate }}
                    <i class="pi pi-arrow-right"></i>
                  </a>

                  <a
                    *ngIf="featureItem.route"
                    class="landing-card-link"
                    [routerLink]="featureItem.route"
                    (click)="closeMenu()"
                  >
                    {{ 'landing.learn_more' | translate }}
                    <i class="pi pi-arrow-right"></i>
                  </a>
                </article>
              </div>
            </div>

            <div class="landing-features__group">
              <div class="landing-features__group-header">
                <div class="landing-chip landing-features__eyebrow">{{ 'landing.feature_grid.badge' | translate }}</div>
                <span class="landing-section-pretitle">{{ 'landing.feature_grid.tools_title' | translate }}</span>
                <p class="landing-section-copy">{{ 'landing.intro_content' | translate }}</p>
              </div>
            </div>

            <div class="grid grid-nogutter landing-card-grid landing-card-grid--tools">
              <div *ngFor="let featureItem of toolItems" class="col-12 md:col-6 lg:col-3 landing-card-grid__item">
                <article class="landing-feature-card">
                  <i [class]="featureItem.icon + ' landing-feature-card__icon'"></i>
                  <span class="landing-feature-card__title">{{ featureItem.titleKey | translate }}</span>
                  <span class="landing-feature-card__description">{{ featureItem.descriptionKey | translate }}</span>

                  <a
                    *ngIf="featureItem.section"
                    class="landing-card-link"
                    [href]="featureItem.section"
                    (click)="handleFeatureNavigation($event, featureItem)"
                  >
                    {{ 'landing.learn_more' | translate }}
                    <i class="pi pi-arrow-right"></i>
                  </a>

                  <a
                    *ngIf="featureItem.route"
                    class="landing-card-link"
                    [routerLink]="featureItem.route"
                    (click)="closeMenu()"
                  >
                    {{ 'landing.learn_more' | translate }}
                    <i class="pi pi-arrow-right"></i>
                  </a>
                </article>
              </div>
            </div>

            <section class="landing-showcase-stack">
              <article class="landing-showcase-block">
                <div class="landing-showcase-block__content">
                  <div class="landing-chip landing-showcase-block__eyebrow">{{ 'landing.showcase.community.badge' | translate }}</div>
                  <h2 class="landing-showcase-block__title">{{ 'landing.showcase.community.title' | translate }}</h2>
                  <p class="landing-showcase-block__description">{{ 'landing.showcase.community.description' | translate }}</p>

                  <ul class="landing-showcase-block__list">
                    <li>{{ 'landing.showcase.community.bullet_1' | translate }}</li>
                    <li>{{ 'landing.showcase.community.bullet_2' | translate }}</li>
                    <li>{{ 'landing.showcase.community.bullet_3' | translate }}</li>
                  </ul>

                  <a class="landing-showcase-block__cta" [routerLink]="['/events']" (click)="closeMenu()">
                    {{ 'landing.showcase.community.cta' | translate }}
                    <i class="pi pi-arrow-right"></i>
                  </a>
                </div>

                <div class="landing-showcase-block__media">
                  <img [attr.draggable]="false" [src]="communityShowcaseImage" alt="" class="landing-showcase-block__image" />
                </div>
              </article>

              <article class="landing-showcase-block landing-showcase-block--reverse">
                <div class="landing-showcase-block__media">
                  <img [attr.draggable]="false" [src]="visibilityShowcaseImage" alt="" class="landing-showcase-block__image" />
                </div>

                <div class="landing-showcase-block__content">
                  <div class="landing-chip landing-showcase-block__eyebrow">{{ 'landing.showcase.visibility.badge' | translate }}</div>
                  <h2 class="landing-showcase-block__title">{{ 'landing.showcase.visibility.title' | translate }}</h2>
                  <p class="landing-showcase-block__description">{{ 'landing.showcase.visibility.description' | translate }}</p>

                  <ul class="landing-showcase-block__list">
                    <li>{{ 'landing.showcase.visibility.bullet_1' | translate }}</li>
                    <li>{{ 'landing.showcase.visibility.bullet_2' | translate }}</li>
                    <li>{{ 'landing.showcase.visibility.bullet_3' | translate }}</li>
                  </ul>

                  <a class="landing-showcase-block__cta" [routerLink]="['/marketplace']" (click)="closeMenu()">
                    {{ 'landing.showcase.visibility.cta' | translate }}
                    <i class="pi pi-arrow-right"></i>
                  </a>
                </div>
              </article>
            </section>

            <section id="collaboration" class="landing-split-section landing-split-section--reverse">
              <div class="landing-split-section__content landing-split-section__content--right">
                <div class="landing-chip landing-split-section__eyebrow">{{ 'landing.collaboration.badge' | translate }}</div>
                <h1 class="landing-gradient-title landing-gradient-title--section">{{ 'landing.collaboration.title' | translate }}</h1>
                <h2 class="landing-split-section__subheading">{{ 'landing.mission_slogan_2_title' | translate }}</h2>
                <p class="landing-split-section__description">{{ 'landing.mission_slogan_2_content' | translate }}</p>
                <p class="landing-split-section__description landing-split-section__description--secondary">{{ 'landing.collaboration.description' | translate }}</p>
              </div>

              <div class="landing-split-section__media">
                <img [attr.draggable]="false" [src]="collaborationImage" alt="collaboration" class="landing-split-section__image" />
              </div>
            </section>

            <section id="events" class="landing-split-section">
              <div class="landing-split-section__media">
                <img [attr.draggable]="false" [src]="eventsImage" alt="events" class="landing-split-section__image" />
              </div>

              <div class="landing-split-section__content">
                <div class="landing-chip landing-split-section__eyebrow">{{ 'landing.events.badge' | translate }}</div>
                <h1 class="landing-gradient-title landing-gradient-title--section">{{ 'landing.events.title' | translate }}</h1>
                <h2 class="landing-split-section__subheading">{{ 'landing.mission_slogan_3_title' | translate }}</h2>
                <p class="landing-split-section__description">{{ 'landing.mission_slogan_3_content' | translate }}</p>
                <p class="landing-split-section__description landing-split-section__description--secondary">{{ 'landing.events.description' | translate }}</p>
              </div>
            </section>

            <section id="video" class="landing-showreels">
              <div class="landing-chip">{{ 'landing.showreels.badge' | translate }}</div>
              <h1 class="landing-gradient-title landing-gradient-title--section">{{ 'landing.showreels.title' | translate }}</h1>
              <h2 class="landing-showreels__subheading">{{ 'landing.mission_slogan_4_title' | translate }}</h2>
              <p class="landing-showreels__description">{{ 'landing.mission_slogan_4_content' | translate }}</p>
              <p class="landing-showreels__description landing-showreels__description--secondary">{{ 'landing.showreels.description' | translate }}</p>

<!--              <div class="landing-showreels__frame">-->
<!--                <iframe-->
<!--                  class="landing-showreels__iframe"-->
<!--                  width="600"-->
<!--                  height="400"-->
<!--                  src=""-->
<!--                  title="Watch This Garage"-->
<!--                  loading="lazy"-->
<!--                  referrerpolicy="strict-origin-when-cross-origin"-->
<!--                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"-->
<!--                  allowfullscreen-->
<!--                ></iframe>-->

<!--                <div class="landing-showreels__ellipse landing-showreels__ellipse&#45;&#45;left">-->
<!--                  <img [attr.draggable]="false" [src]="ellipseImage" alt="" />-->
<!--                </div>-->

<!--                <div class="landing-showreels__ellipse landing-showreels__ellipse&#45;&#45;right-large">-->
<!--                  <img [attr.draggable]="false" [src]="ellipseImageSecondary" alt="" />-->
<!--                </div>-->

<!--                <div class="landing-showreels__ellipse landing-showreels__ellipse&#45;&#45;right-small">-->
<!--                  <img [attr.draggable]="false" [src]="ellipseImageSecondary" alt="" />-->
<!--                </div>-->
<!--              </div>-->
            </section>

            </ng-container>

            <section id="newsletter" class="landing-newsletter">
              <div class="landing-newsletter-band">
                <div class="landing-newsletter-band__copy">
                  <span class="landing-newsletter-band__eyebrow">{{ 'landing.newsletter.badge' | translate }}</span>
                  <h1 class="landing-newsletter-band__title">{{ 'landing.newsletter.title' | translate }}</h1>
                  <p class="landing-newsletter-band__lead">{{ 'landing.newsletter_slogan' | translate }}</p>
                  <p class="landing-newsletter-band__description">{{ 'landing.newsletter.description' | translate }}</p>
                </div>

                <div class="landing-newsletter-band__form" [formGroup]="form">
                  <div class="landing-newsletter-band__field">
                    <div class="p-float-label p-input-icon-left">
                      <i class="pi pi-user"></i>
                      <input type="text" pInputText id="first-name" formControlName="firstName">
                      <label for="first-name">{{ 'landing.newsletter.name_label' | translate }}</label>
                    </div>
                  </div>

                  <div class="landing-newsletter-band__field">
                    <div class="p-float-label p-input-icon-left">
                      <i class="pi pi-at"></i>
                      <input type="email" pInputText id="email" formControlName="email">
                      <label for="email">{{ 'common.email' | translate }}</label>
                    </div>

                    <div class="app-form-error" *ngIf="form.controls['email'].invalid && form.controls['email'].touched">
                      <p *ngIf="form.controls['email'].errors.required">{{ 'auth.registration.validation.required_email' | translate }}</p>
                      <p *ngIf="form.controls['email'].errors.email">{{ 'auth.registration.validation.email' | translate }}</p>
                      <p *ngIf="form.controls['email'].errors.custom">{{ form.controls['email'].errors.custom }}</p>
                    </div>
                  </div>

                  <button
                    pButton
                    pRipple
                    type="button"
                    (click)="submit()"
                    [label]="'common.i_sign_up' | translate"
                    [loading]="loading"
                    class="landing-newsletter-band__submit"
                  ></button>
                </div>
              </div>
            </section>

            <footer class="landing-footer">
              <div class="grid grid-nogutter">
                <div class="col-12 lg:col-3 landing-footer__col">
                  <div class="landing-footer__column">
                    <h1 class="landing-footer__heading">{{ 'landing.footer.contact' | translate }}</h1>
                    <img [src]="footerLogoType" alt="Watch This Garage" class="landing-footer__logo">
                    <p class="landing-footer__copy">{{ 'landing.footer.brand_copy' | translate }}</p>
                    <span class="landing-footer__meta">WatchThisGarage v. {{ version }}</span>
                    <span class="landing-footer__meta">{{ 'landing.store_soon' | translate }}</span>

                    <div class="landing-footer__socials">
                      <a *ngFor="let socialLink of socialLinks" [href]="socialLink.href" target="_blank" rel="noopener noreferrer" [attr.aria-label]="socialLink.label">
                        <i [class]="socialLink.icon"></i>
                      </a>
                    </div>

                    <div class="landing-footer__stores">
                      <a href="https://play.google.com/store" target="_blank" rel="noopener noreferrer">
                        <img [src]="storeBadges.google" alt="Get it on Google Play">
                      </a>
                      <a href="https://www.apple.com/app-store/" target="_blank" rel="noopener noreferrer">
                        <img [src]="storeBadges.apple" alt="Download on the App Store">
                      </a>
                    </div>
                  </div>
                </div>

                <div class="col-12 lg:col-3 landing-footer__col">
                  <div class="landing-footer__column">
                    <h1 class="landing-footer__heading">{{ 'landing.footer.explore' | translate }}</h1>
                    <a
                      *ngFor="let footerExploreLink of visibleFooterExploreLinks"
                      [href]="footerExploreLink.section"
                      class="landing-footer__link"
                      (click)="handleSectionNavigation($event, footerExploreLink.section!)"
                    >
                      {{ footerExploreLink.labelKey | translate }}
                    </a>
                  </div>
                </div>

                <div class="col-12 lg:col-3 landing-footer__col">
                  <div class="landing-footer__column">
                    <h1 class="landing-footer__heading">{{ 'landing.footer.sections' | translate }}</h1>
                    <a *ngFor="let footerRouteLink of footerRouteLinks" [routerLink]="footerRouteLink.route" class="landing-footer__link">
                      {{ footerRouteLink.labelKey | translate }}
                    </a>
                  </div>
                </div>

                <div class="col-12 lg:col-3 landing-footer__col">
                  <div class="landing-footer__column">
                    <h1 class="landing-footer__heading">{{ 'landing.footer.legal' | translate }}</h1>
                    <a *ngFor="let page of footerPages" [routerLink]="resolvePageRoute(page)" class="landing-footer__link">
                      {{ page.title }}
                    </a>
                  </div>
                </div>
              </div>
            </footer>
          </div>
        </section>
      </div>
    </div>
  </div>
</div>
